module.exports = __webpack_public_path__ + "assets/boomerang-pr.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-pr.png
// module id = 297
// module chunks = 0